import { useDispatch } from "react-redux";
import { renderStatus } from "../../../../../Utils/CommonUtils";
import { Link } from "react-router-dom";

const useRolesColumns = () => {
  const dispatch = useDispatch();

  const rolesColumns = [
    {
      header: "Code",
      accessorKey: "code",
      cell: (props) => (
        <Link
          className="table-drilling-link"
          to={`/team/role/update/${props.row.original.entityid}`}
        >
          {props?.getValue() ? props?.getValue() : "-"}
        </Link>
      ),
      size: 30,
    },
    {
      header: "Name",
      accessorKey: "name",
      cell: (props) => (props?.getValue() ? props?.getValue() : "-"),
      size: 600,
    },
    // {
    //   header: "Organization Type",
    //   accessorKey: "orgtype",
    //   cell: (props) => (props?.getValue() ? props?.getValue() : "-"),
    //   size: 200,
    // },
    // {
    //   header: "Contact Person",
    //   accessorKey: "",
    //   cell: (props) => (props?.getValue() ? props?.getValue() : "-"),
    //   size: 200,
    // },
    // {
    //   header: "Contact Number",
    //   accessorKey: "no.",
    //   cell: (props) => (props?.getValue() ? props?.getValue() : "-"),
    //   size: 200,
    // },

    {
      header: "Status",
      accessorKey: "status",
      cell: (props) =>
        props?.getValue() ? renderStatus(props?.getValue()) : "-",
      size: 100,
    },
    // {
    //   header: "Action",
    //   accessorKey: "action",
    //   cell: (props) => (
    //     <div className="action-icons text-center">
    //       <span
    //         // className="btn btn-sm btn-soft-info edit-list"
    //         onClick={() => {
    //           dispatch(openModal(true));
    //           dispatch(editModal(true));
    //           dispatch(updateRendererFormState(props?.row?.original));
    //           dispatch(setRolesEditID(props?.row?.original?.entityid));
    //           dispatch(setRolesEditCode(props?.row?.code));
    //         }}
    //       >
    //         {/* <i className="ri-pencil-fill align-bottom" /> */}
    //         <EditListIcon />
    //       </span>
    //     </div>
    //   ),
    //   meta: { align: "center" },
    //   size: 70,
    // },
  ];

  return { rolesColumns };
};

export default useRolesColumns;
